import { render, staticRenderFns } from "./TransferInventory.vue?vue&type=template&id=2ca4af2c&scoped=true"
import script from "./TransferInventory.vue?vue&type=script&lang=js"
export * from "./TransferInventory.vue?vue&type=script&lang=js"
import style0 from "./TransferInventory.vue?vue&type=style&index=0&id=2ca4af2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4af2c",
  null
  
)

export default component.exports